"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveUpdateAction = exports.useUpdateCollectionDialog = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const abortable_fetch_1 = require("../../../utils/abortable-fetch");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const collection_dialog_1 = require("../collection-dialog");
const collection_schema_1 = require("../collection-schema");
function useUpdateCollectionDialog(getUrl) {
    const callApi = (0, event_callback_hook_1.useEventCallback)((id, collectionId, formData) => {
        return (0, abortable_fetch_1.abortableFetch)(`${getUrl(id, collectionId)}`, {
            method: 'PUT',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify(formData),
        });
    });
    return {
        callApi,
    };
}
exports.useUpdateCollectionDialog = useUpdateCollectionDialog;
function resolveUpdateAction(props) {
    return {
        hide: false,
        useApi: useUpdateCollectionDialog,
        label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__COLLECTION__UPDATE_LABEL", defaultMessage: "Upravit" })),
        title: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__COLLECTION__UPDATE_TITLE", defaultMessage: "\u00DAprava" })),
        text: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__COLLECTION__UPDATE_TEXT", defaultMessage: "Vypl\u0148te formul\u00E1\u0159" })),
        Dialog: collection_dialog_1.CollectionDialog,
        dialogWidth: 400,
        useSchema: collection_schema_1.useValidationSchema,
        ...props,
    };
}
exports.resolveUpdateAction = resolveUpdateAction;
//# sourceMappingURL=update-collection-hook.js.map